import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiEdit3, FiFilter, FiVideo, FiCheckCircle } = FiIcons;

const HowItWorks = () => {
  const steps = [
    {
      icon: FiEdit3,
      title: 'Publish Job',
      description: 'Post to careers pages & channels in one click'
    },
    {
      icon: FiFilter,
      title: 'Auto-Shortlist',
      description: 'Resume parsing + filters + AI pre-score'
    },
    {
      icon: FiVideo,
      title: 'AI Interview',
      description: 'WhatsApp/Email invites; video interviews; AI analysis & proxy detection'
    },
    {
      icon: FiCheckCircle,
      title: 'Decide & Hire',
      description: 'Compare scores, panel feedback, schedule interviews'
    }
  ];

  return (
    <section id="how-it-works" className="py-16 lg:py-24 bg-slate-50 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="font-display font-bold text-3xl lg:text-5xl text-slate-900 mb-6">
            How It Works
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            Four simple steps to transform your hiring process from chaos to clarity
          </p>
        </motion.div>

        <div className="relative">
          
          {/* MOBILE LINE: Vertical (Top to Bottom) */}
          <div className="lg:hidden absolute left-1/2 top-4 bottom-12 w-1 bg-gradient-to-b from-indigo-200 via-purple-400 to-indigo-200 transform -translate-x-1/2 rounded-full"></div>

          {/* DESKTOP LINE: Horizontal (Left to Right) */}
          <div className="hidden lg:block absolute top-8 left-4 right-4 h-1 bg-gradient-to-r from-indigo-200 via-purple-400 to-indigo-200 rounded-full"></div>

          <div className="grid grid-cols-1 lg:grid-cols-4 gap-12 lg:gap-8">
            {steps.map((step, index) => (
              <motion.div
                key={index}
                className="relative z-10"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.2 }}
                viewport={{ once: true }}
              >
                {/* Step Number & Icon */}
                <div className="flex justify-center mb-6">
                  {/* bg-slate-50 masks the line running behind the icon */}
                  <div className="relative bg-slate-50 p-2 rounded-full"> 
                    <div className="w-16 h-16 bg-white border-4 border-indigo-100 rounded-full flex items-center justify-center shadow-lg relative z-20">
                      <SafeIcon icon={step.icon} className="w-8 h-8 text-indigo-600" />
                    </div>
                    
                    {/* Number Badge */}
                    <div className="absolute -top-1 -right-1 z-30 w-8 h-8 bg-gradient-to-br from-indigo-600 to-purple-600 text-white rounded-full flex items-center justify-center text-sm font-bold shadow-md border-2 border-white">
                      {index + 1}
                    </div>
                  </div>
                </div>

                <div className="text-center px-2 bg-slate-50/80 backdrop-blur-sm rounded-xl py-2">
                  <h3 className="font-semibold text-xl text-slate-900 mb-3">
                    {step.title}
                  </h3>
                  <p className="text-slate-600 leading-relaxed text-sm lg:text-base">
                    {step.description}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>

        <motion.div
          className="text-center mt-12 lg:mt-16"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.8 }}
          viewport={{ once: true }}
        >
          <button className="bg-indigo-600 text-white font-semibold px-8 py-4 rounded-lg hover:bg-indigo-700 transition-all shadow-lg hover:shadow-indigo-500/30 transform hover:-translate-y-1">
            Try on Demo Job
          </button>
        </motion.div>
      </div>
    </section>
  );
};

export default HowItWorks;